import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ListitemBuilder } from '../../../../../shared/dropdown-list/ListItemBuilder';
import { FiltroDataComponent } from '../../../../../shared/filtro-data/filtro-data.component';
import { FiltroService } from '../../../../../shared/filtro/filtro.service';
import { BiRelatorioAnaliseService } from '../bi-relatorio-analise.service';

@Component({
  selector: 'app-bi-relatorio-analise-filtro',
  templateUrl: './bi-relatorio-analise-filtro.component.html',
  styleUrls: ['./bi-relatorio-analise-filtro.component.css']
})
export class RelatorioAnaliseGeralFiltroComponent implements OnInit {

  @Input() filtros: any;
  mercado = [];
  gruposEconomicos = [];
  regioes = [];
  dealers = [];
  funcao = [];
  Sysdate: FiltroDataComponent = new FiltroDataComponent;

  max;       // Set a valid date

  habGrupoEconomico = false;
  habDealer = false;
  habRegiao = false;

  parametrosFiltro: any;
  ano: any;
  mes_inicial: any;
  mes_final: any;

  anoAtual = new Date();
  anoAnterior = new Date();
  anoRetrasado = new Date();
  anoDropDown = {};

  constructor(private servico: FiltroService, router: Router, private route: ActivatedRoute) {

    this.route.queryParams.subscribe(params => {
      this.parametrosFiltro = params;
      this.setaValorData(params['ano'], params['mes_inicial'], params['mes_final']);
    });
  }

  ngOnInit() {
    this.preencherMercados();
    this.preencherGruposEconomicos();
    this.preencherRegioes();
    this.preencherDealers();
    this.carregarAno();
    this.geraAnoDropDown();
    this.carregarMesInicial();
    this.carregarMesFinal();
  }

  setaValorData(ano: any, mes_inicial: any, mes_final: any) {
    if (ano === undefined || ano === null) {
      this.ano = this.anoAtual.getFullYear();
    }

    if (mes_inicial === undefined || mes_inicial === null) {
      this.mes_inicial = 1;
    }

    if (mes_final === undefined || mes_final === null) {
      this.mes_final = 12;
    }
    this.filtros = { ano: this.ano, mes_inicial: this.mes_inicial, mes_final: this.mes_final };
  }

  preencherMercados() {
    this.servico.buscar('mercado')
      .then(r => { this.mercado = r.filtros; });
  }

  preencherGruposEconomicos() {
    this.servico.buscar('grupo_economico')
      .then(r => { this.gruposEconomicos = r.filtros; });
  }

  preencherRegioes() {
    this.servico.buscar('regiao')
      .then(r => { this.regioes = r.filtros; });
  }

  preencherDealers() {

    if (this.GrupoEconomico !== '') {

      this.servico.buscar('dealerGrupo/'.concat(this.GrupoEconomico))
        .then(r => { this.dealers = r.filtros; });

    } else {

      this.servico.buscar('dealer')
        .then(r => { this.dealers = r.filtros; });
    }
  }

  set Mercado(id: any) { this.filtros.mercado = this.tratarSetDropDown(id); }
  get Mercado(): any {
    return this.tratarGetDropDown(this.filtros.mercado);
  }

  set GrupoEconomico(id: any) { this.filtros.grupo_economico = this.tratarSetDropDown(id); }
  get GrupoEconomico(): any { return this.tratarGetDropDown(this.filtros.grupo_economico); }

  set Regiao(id: any) { this.filtros.regiao = this.tratarSetDropDown(id); }
  get Regiao(): any { return this.tratarGetDropDown(this.filtros.regiao); }

  set Dealer(id: any) { this.filtros.dealer = this.tratarSetDropDown(id); }
  get Dealer(): any { return this.tratarGetDropDown(this.filtros.dealer); }

  set Funcao(id: any) { this.filtros.funcao = this.tratarSetDropDown(id); }
  get Funcao(): any { return this.tratarGetDropDown(this.filtros.funcao); }

  set Ano(ano: any) { this.filtros.ano = this.tratarSetDropDown(ano); }
  get Ano(): any { return this.tratarGetDropDown(this.filtros.ano); }

  set MesInicial(mes_inicial: any) { this.filtros.mes_inicial = this.tratarSetDropDown(mes_inicial); }
  get MesInicial(): any { return this.tratarGetDropDown(this.filtros.mes_inicial); }

  set MesFinal(mes_final: any) { this.filtros.mes_final = this.tratarSetDropDown(mes_final); }
  get MesFinal(): any { return this.tratarGetDropDown(this.filtros.mes_final); }

  tratarSetDropDown(id: string): number {
    if (id) {
      return +id;
    } else {
      return null;
    }
  }

  tratarGetDropDown(selecionado: any): string {
    if (selecionado === null || selecionado === undefined) {
      return '';
    }
    return selecionado;
  }

  private carregarAno() {
    this.ano =
      new ListitemBuilder()
        .add(1, this.anoRetrasado.getFullYear() - 2)
        .add(2, this.anoAnterior.getFullYear() - 1)
        .add(3, this.anoAtual.getFullYear())
        .build();
  }

  private geraAnoDropDown() {
    this.anoDropDown = [
      { "value": this.anoRetrasado.getFullYear() - 2 },
      { "value": this.anoAnterior.getFullYear() - 1 },
      { "value": this.anoAtual.getFullYear() }
    ]
  }

  private carregarMesInicial() {
    this.mes_inicial =
      new ListitemBuilder()
        .add(1, 1)
        .add(2, 2)
        .add(3, 3)
        .add(4, 4)
        .add(5, 5)
        .add(6, 6)
        .add(7, 7)
        .add(8, 8)
        .add(9, 9)
        .add(10, 10)
        .add(11, 11)
        .add(12, 12)
        .build();
  }

  private carregarMesFinal() {
    this.mes_final =
      new ListitemBuilder()
        .add(1, 1)
        .add(2, 2)
        .add(3, 3)
        .add(4, 4)
        .add(5, 5)
        .add(6, 6)
        .add(7, 7)
        .add(8, 8)
        .add(9, 9)
        .add(10, 10)
        .add(11, 11)
        .add(12, 12)
        .build();
  }

  desabilitaDealer() {
    if (this.GrupoEconomico !== '') {
      this.habDealer = true;
    } else {
      this.habDealer = false;
    }
  }

  desabilitaGrupoEconomico() {
    if (this.Dealer !== '') {
      this.habGrupoEconomico = true;
    } else {
      this.habGrupoEconomico = false;
    }
  }

  selecionaDealer() {
    this.dealers = [];

    this.preencherDealers();
  }

  limpaFiltro(): any {
    this.Mercado = '';
    this.GrupoEconomico = '',
      this.Regiao = '';
    this.Dealer = '';
    this.Ano = this.anoAtual.getFullYear();
    this.MesInicial = 1;
    this.MesFinal = 12;
  }

}
